import { render, staticRenderFns } from "./PatientInfoForm.vue?vue&type=template&id=72ee5172&scoped=true&lang=pug"
import script from "./PatientInfoForm.vue?vue&type=script&lang=js"
export * from "./PatientInfoForm.vue?vue&type=script&lang=js"
import style0 from "./PatientInfoForm.vue?vue&type=style&index=0&id=72ee5172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee5172",
  null
  
)

export default component.exports